import { fade } from "@material-ui/core/styles/colorManipulator";

export const getSharedStorageTransactionStyles = (theme) => ({
	fullScreenDialog: {
		height: "95vh",
		maxHeight: "95vh",
	},
	dialogContent: {
		padding: 0,
		height: "calc(95vh - 64px)",
		display: "flex",
		flexDirection: "column",
		overflow: "hidden",
	},
	formSection: {
		backgroundColor: theme.palette.background.paper,
		padding: theme.spacing(2, 3),
		borderBottom: `2px solid ${theme.palette.divider}`,
		flexShrink: 0,
	},
	formTitle: {
		marginBottom: theme.spacing(1),
		fontSize: "0.75rem",
		color: theme.palette.text.secondary,
		fontWeight: 500,
		textTransform: "uppercase",
		letterSpacing: "0.5px",
	},
	formGrid: {
		alignItems: "flex-start",
	},
	palletsInput: {
		"& .MuiInputBase-root": {
			alignItems: "flex-start",
			alignContent: "flex-start",
		},
		"& .MuiInputBase-root > div:first-child": {
			maxHeight: 120,
			overflowY: "auto",
			flexWrap: "wrap",
		},
	},
	resultsContainer: {
		flex: 1,
		overflow: "auto",
		backgroundColor: theme.palette.background.default,
	},
	resultsSection: {
		padding: theme.spacing(2),
	},
	resultGroup: {
		marginBottom: theme.spacing(2),
		border: `1px solid ${theme.palette.divider}`,
		borderRadius: 4,
		overflow: "hidden",
		backgroundColor: theme.palette.background.paper,
	},
	summaryHeader: {
		backgroundColor: theme.palette.primary.main,
		color: theme.palette.primary.contrastText,
		padding: theme.spacing(1.5, 2),
	},
	summaryChip: {
		backgroundColor: theme.palette.common.white,
		color: theme.palette.primary.main,
		fontWeight: 700,
	},
	summaryRow: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		padding: theme.spacing(0.5, 0),
	},
	summaryLabel: {
		fontSize: "0.875rem",
		fontWeight: 500,
	},
	summaryValue: {
		fontSize: "0.938rem",
		fontWeight: 600,
	},
	columnHeader: {
		padding: theme.spacing(1),
		borderRadius: 4,
		marginBottom: theme.spacing(1.5),
		textAlign: "center",
		fontWeight: 600,
		fontSize: "0.813rem",
		textTransform: "uppercase",
		letterSpacing: "0.5px",
	},
	columnHeaderText: {
		color: theme.palette.common.white,
	},
	palletCard: {
		marginBottom: theme.spacing(1),
		transition: "box-shadow 0.2s",
		borderRadius: 4,
		overflow: "hidden",
		border: `1px solid ${theme.palette.divider}`,
		"&:hover": {
			boxShadow: theme.shadows[2],
		},
	},
	palletCardContent: {
		padding: `${theme.spacing(1.25)}px !important`,
		"&:last-child": {
			paddingBottom: `${theme.spacing(1.25)}px !important`,
		},
	},
	palletRow: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		padding: theme.spacing(0.5, 0),
		"&:not(:last-child)": {
			borderBottom: `1px solid ${theme.palette.divider}`,
		},
	},
	palletLabel: {
		fontSize: "0.75rem",
		fontWeight: 600,
		color: theme.palette.text.secondary,
		textTransform: "uppercase",
	},
	palletValue: {
		fontSize: "0.875rem",
		fontWeight: 600,
		color: theme.palette.text.primary,
		textAlign: "right",
		wordBreak: "break-word",
		maxWidth: "65%",
	},
	emptyState: {
		textAlign: "center",
		padding: theme.spacing(3),
		color: theme.palette.text.secondary,
		backgroundColor: theme.palette.background.default,
		borderRadius: 4,
		border: `1px dashed ${theme.palette.divider}`,
		fontSize: "0.813rem",
	},
	noResults: {
		textAlign: "center",
		padding: theme.spacing(8),
		color: theme.palette.text.secondary,
		fontSize: "0.938rem",
	},
	timestamp: {
		fontSize: "0.688rem",
		opacity: 0.9,
		marginTop: theme.spacing(0.5),
	},
	loadingBackdrop: {
		position: "absolute",
		zIndex: 1000,
		backgroundColor: fade(theme.palette.common.white, 0.8),
	},
});
